import { sidebarStorageKey } from "./appShell.constants";

export function isSelectedPath(pathname: string, targetPath: string) {
    return pathname === targetPath || pathname.startsWith(`${targetPath}/`);
}

export function getInitialDesktopCollapsed() {
    if (typeof window === "undefined") {
        return false;
    }

    if (window.innerWidth < 900) {
        return false;
    }

    return localStorage.getItem(sidebarStorageKey) === "collapsed";
}

/** Име за поздрав в страничния панел (без префикс Retail). */
export function getSidebarGreetingName(fullName?: string | null) {
    const normalized = (fullName ?? "").trim().replace(/^retail\s+/iu, "").trim();

    return normalized || (fullName ?? "").trim();
}
